var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduIdIcs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.0688V7.93125L1.5 5.325V10.4625L6 13.0688ZM7.5 13.0688L12 10.4625V5.325L7.5 7.93125V13.0688ZM6.75 6.6375L11.1938 4.06875L6.75 1.5L2.30625 4.06875L6.75 6.6375ZM0.75 11.775C0.5125 11.6375 0.328125 11.4563 0.196875 11.2313C0.065625 11.0063 0 10.7563 0 10.4813V4.51875C0 4.24375 0.065625 3.99375 0.196875 3.76875C0.328125 3.54375 0.5125 3.3625 0.75 3.225L6 0.20625C6.2375 0.06875 6.4875 0 6.75 0C7.0125 0 7.2625 0.06875 7.5 0.20625L12.75 3.225C12.9875 3.3625 13.1719 3.54375 13.3031 3.76875C13.4344 3.99375 13.5 4.24375 13.5 4.51875V10.4813C13.5 10.7563 13.4344 11.0063 13.3031 11.2313C13.1719 11.4563 12.9875 11.6375 12.75 11.775L7.5 14.7938C7.2625 14.9313 7.0125 15 6.75 15C6.4875 15 6.2375 14.9313 6 14.7938L0.75 11.775Z",
    fill: "#8790A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduIdIcs);
export default __webpack_public_path__ + "static/media/produ_id_ics.f5d66ac301399455913eee8e4b0a63bb.svg";
export { ForwardRef as ReactComponent };